import Header from '../../../Components/Header'
import { Helmet } from 'react-helmet'
import TableLayout from './TableLayout'

const OldGoldEntryList = () => {

    return (
        <div className='d-flex flex-column' style={{ minHeight: '99.7vh' }}>
            <Helmet>
                <title>old-gold-entry-list</title>
            </Helmet>
            <Header />
            <TableLayout />
        </div>
    )
}

export default OldGoldEntryList